module.exports = __webpack_public_path__ + "img/33.6546225c.png";